export default __webpack_public_path__ + "static/media/getmee-watermark.347575fb.svg";